module.exports = __webpack_public_path__ + "img/reward_200.2843ac6f.png";